'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _navItemMobile = require('./navItemMobile');

var _navItemMobile2 = _interopRequireDefault(_navItemMobile);

var _reactI18next = require('react-i18next');

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _lodash = require('lodash');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BuildMobileSecNav(props) {
    var _useTranslation = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation.t;

    return props.showMobileMenu && _react2.default.createElement(
        'div',
        { className: 'm-outer-icon d-flex d-lg-none justify-content-end ml-auto align-items-center mMeun' },
        _react2.default.createElement(
            'div',
            { id: 'mobile-menu', className: 'mobile-menu' },
            _react2.default.createElement(
                'div',
                { className: 'main-page' },
                !(0, _lodash.isEmpty)(t("pages", { returnObjects: true })) && t("pages", { returnObjects: true }).map(function (obj, key) {
                    if (!obj.DesktopDisplayOnly) {
                        return _react2.default.createElement(_navItemMobile2.default, {
                            key: obj.key || key,
                            itemIndex: key,
                            isActive: key == props.subNavLV2Index,
                            itemContent: obj,
                            handleMouseEnter: props.handleMenuMouseEnter,
                            onURLClick: props.onURLClick,
                            setShowMobileMenu: props.setShowMobileMenu,
                            setSubNavLV2Index: props.setSubNavLV2Index
                            //handleItemClick={props.handleItemClick.bind(this)}
                        });
                    }
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'sub-page mt-2' },
                !(0, _lodash.isEmpty)(t("topMiniNav", { returnObjects: true })) && t("topMiniNav", { returnObjects: true }).map(function (obj, key) {
                    if (!obj.DesktopDisplayOnly) {
                        return _react2.default.createElement(
                            'a',
                            {
                                className: 'nav-link',
                                href: obj.url,
                                key: key,
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    props.onURLClick(obj.url, 'topMiniNav');
                                    props.setShowMobileMenu(!props.showMobileMenu);
                                },
                                style: { color: obj.color }
                            },
                            (0, _reactHtmlParser2.default)(obj.title)
                        );
                    }
                }),
                _react2.default.createElement(
                    'a',
                    { onClick: function onClick() {
                            props.handleChangeLang(_i18next2.default.language === 'en-US' ? "zh-HK" : "en-US");
                        } },
                    _react2.default.createElement(
                        'div',
                        { className: 'px-3 py-2 item langChange' },
                        _i18next2.default.language === 'en-US' ? '繁' : 'EN'
                    )
                )
            )
        )
    );
}

exports.default = BuildMobileSecNav;